<template>
  <div class="container-center">
    <!-- 公共头部 -->
    <home-header></home-header>
    <div class="content-wrap">
      <img src="../../assets/images/yunkang/pic01.png" class="img">
      <img src="../../assets/images/yunkang/pic02.png" class="img">
      <img src="../../assets/images/yunkang/pic03.png" class="img">
      <img src="../../assets/images/yunkang/pic04.png" class="img">
      <img src="../../assets/images/yunkang/pic06.png" class="img">
      <img src="../../assets/images/yunkang/pic05.png" class="img">
      <img src="../../assets/images/yunkang/pic07.png" class="img">
      <img src="../../assets/images/yunkang/pic08.png" class="img">
      <img src="../../assets/images/yunkang/pic09.png" class="img">
    </div>
    <!-- 公共版权 -->
    <home-footer></home-footer>
  </div>
</template>
<script>
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/homeFooter";

export default {
  name: "",
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {
  }
};
</script>
<style scoped>
.content-wrap{
}
.img{
  width: 100%;
  height: 100%;
}

</style>




// WEBPACK FOOTER //
// src/pages/admissions/healthPage.vue